<template>
    <div class="product-manage" v-loading="loadAll">
        <!-- 左侧：产品列表 -->
        <div class="shadow-box left-panel">
            <el-table ref="productTableRef" :data="productData" row-key="id" highlight-current-row @current-change="handleProductSelect"
                :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333'}">
                <el-table-column prop="name" label="产品名称" min-width="100" align="left"></el-table-column>
                <el-table-column prop="engName" label="英文名称" min-width="90" align="left">
                    <template slot-scope="{row}">{{ row.engName || '--' }}</template>
                </el-table-column>
                <el-table-column prop="sort" label="顺序" min-width="60" align="center"></el-table-column>
                <el-table-column label="操作" min-width="90" align="center">
                    <template slot-scope="{row}">
                        <el-button type="text" style="padding: 0;" @click.stop="moreProductOperation('edit', row)">编辑</el-button>
                        <el-divider direction="vertical"></el-divider>
                        <el-popconfirm title="确定删除此产品吗？产品对应的子版本将一并删除" @confirm="deleteProductItem(row)">
                            <el-button slot="reference" type="text" style="padding: 0;" @click.stop>删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 右侧：版本管理 -->
        <div class="shadow-box right-panel">
            <div class="version-title">
                <span>{{ currentProduct ? currentProduct.name + ' - 版本列表' : '版本列表' }}</span>
                <el-button type="primary" size="small" icon="el-icon-plus" :disabled="!currentProduct" @click="moreVersionOperation('add')">新增版本</el-button>
            </div>
            <el-empty v-if="!currentProduct" description="请先在左侧选择产品" :image-size="80"></el-empty>
            <el-table v-else :data="currentProduct.versionList"
                :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333'}">
                <el-table-column prop="name" label="版本名称" min-width="100" align="left"></el-table-column>
                <el-table-column prop="sort" label="顺序" min-width="60" align="center"></el-table-column>
                <el-table-column prop="remark" label="备注" min-width="120" align="left">
                    <template slot-scope="{row}">{{ row.remark || '--' }}</template>
                </el-table-column>
                <el-table-column label="操作" min-width="90" align="center">
                    <template slot-scope="{row}">
                        <el-button type="text" style="padding: 0;" @click="moreVersionOperation('edit', row)">编辑</el-button>
                        <el-divider direction="vertical"></el-divider>
                        <el-popconfirm title="确定删除此版本吗？" @confirm="deleteVersionItem(row)">
                            <el-button slot="reference" type="text" style="padding: 0;">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 新增/编辑产品 -->
        <el-drawer :title="`${productEditId ? '编辑' : '新增'}产品`" :visible.sync="productDrawer" size="30rem" direction="rtl" custom-class="add-drawer"
            :wrapperClosable="false">
            <el-form ref="productFormRef" :model="productForm" :rules="productRules" label-position="left" label-width="90px">
                <el-form-item label="产品名称" prop="name">
                    <el-input v-model="productForm.name" placeholder="请输入产品名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="英文名称" prop="engName">
                    <el-input v-model="productForm.engName" placeholder="请输入英文名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="顺序" prop="sort">
                    <el-input v-model.number="productForm.sort" placeholder="请输入顺序" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="productForm.remark" type="textarea" :rows="3" placeholder="请输入备注" clearable></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button :loading="loadSaveProduct" @click="confirmProduct" class="save-btn">保存</el-button>
                </el-form-item>
            </el-form>
            <drawer-close :visible="productDrawer" right="30rem" @close="productDrawer = false"></drawer-close>
        </el-drawer>

        <!-- 新增/编辑版本 -->
        <el-drawer :title="`${versionEditId ? '编辑' : '新增'}版本`" :visible.sync="versionDrawer" size="30rem" direction="rtl" custom-class="add-drawer"
            :wrapperClosable="false">
            <el-form ref="versionFormRef" :model="versionForm" :rules="versionRules" label-position="left" label-width="90px">
                <el-form-item label="版本名称" prop="name">
                    <el-input v-model="versionForm.name" placeholder="请输入版本名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="顺序" prop="sort">
                    <el-input v-model.number="versionForm.sort" placeholder="请输入顺序" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="versionForm.remark" type="textarea" :rows="3" placeholder="请输入备注" clearable></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button :loading="loadSaveVersion" @click="confirmVersion" class="save-btn">保存</el-button>
                </el-form-item>
            </el-form>
            <drawer-close :visible="versionDrawer" right="30rem" @close="versionDrawer = false"></drawer-close>
        </el-drawer>
    </div>
</template>

<script>
import { findProductManageList, saveProduct, updateProduct, deleteProduct, saveProductVersion, updateProductVersion, deleteProductVersion } from '@/api/setting/index.js';

export default {
    name: 'productManage',
    data() {
        return {
            loadAll: false,
            productData: [],
            currentProduct: null,
            currentProductId: null,
            // 新增/编辑产品
            productDrawer: false,
            productEditId: '',
            loadSaveProduct: false,
            productForm: {
                name: '',
                engName: '',
                sort: '',
                remark: '',
            },
            productRules: {
                name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
            },
            // 新增/编辑版本
            versionDrawer: false,
            versionEditId: '',
            loadSaveVersion: false,
            versionForm: {
                name: '',
                sort: '',
                remark: '',
            },
            versionRules: {
                name: [{ required: true, message: '请输入版本名称', trigger: 'blur' }],
            },
        }
    },
    created() {
        this.fetchProductData();
    },
    methods: {
        // 获取产品列表（含版本），刷新后恢复选中产品的高亮
        fetchProductData() {
            this.loadAll = true;
            findProductManageList().then(res => {
                this.loadAll = false;
                this.productData = res.data;
                if (this.currentProductId) {
                    let found = this.productData.find(x => x.id === this.currentProductId);
                    if (found) {
                        // 换成新数据中的引用，避免表格内部 currentRow 指向旧对象
                        this.currentProduct = found;
                        this.$nextTick(() => {
                            this.$refs.productTableRef?.setCurrentRow(found);
                        });
                    } else {
                        // 选中产品已被删除
                        this.currentProductId = null;
                        this.currentProduct = null;
                    }
                }
            }).catch((err) => {
                this.loadAll = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        // 选中产品（数据刷新导致 current-change(null) 时不清空选中）
        handleProductSelect(row) {
            if (row) {
                this.currentProductId = row.id;
                this.currentProduct = row;
            } else if (!this.currentProductId) {
                this.currentProduct = null;
            }
        },
        // 新增产品（父组件"新增产品"按钮入口）
        moreOperation(type, item) {
            this.moreProductOperation(type, item);
        },
        // 产品操作
        moreProductOperation(type, item) {
            if (type == 'add') {
                this.productDrawer = true;
                this.productEditId = '';
                this.productForm = { name: '', engName: '', sort: '', remark: '' };
            } else if (type == 'edit') {
                this.productDrawer = true;
                this.productEditId = item.id;
                this.productForm = {
                    name: item.name,
                    engName: item.engName,
                    sort: item.sort,
                    remark: item.remark,
                };
            }
            this.$nextTick(() => {
                this.$refs.productFormRef?.clearValidate();
            })
        },
        // 确认新增/编辑产品
        confirmProduct() {
            this.$refs.productFormRef.validate(valid => {
                if (!valid) return;
                this.loadSaveProduct = true;
                let req = this.productEditId ? updateProduct : saveProduct;
                req({
                    id: this.productEditId ? this.productEditId : undefined,
                    ...this.productForm,
                }).then(() => {
                    this.loadSaveProduct = false;
                    this.productDrawer = false;
                    this.$MessageBox.MessageSuccess('保存成功');
                    this.fetchProductData();
                }).catch((err) => {
                    this.loadSaveProduct = false;
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
            })
        },
        // 删除产品
        deleteProductItem(row) {
            deleteProduct({ id: row.id }).then(() => {
                if (this.currentProductId === row.id) {
                    this.currentProductId = null;
                    this.currentProduct = null;
                }
                this.$MessageBox.MessageSuccess('删除成功');
                this.fetchProductData();
            }).catch((err) => {
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        // 版本操作
        moreVersionOperation(type, item) {
            if (type == 'add') {
                this.versionDrawer = true;
                this.versionEditId = '';
                this.versionForm = { name: '', sort: '', remark: '' };
            } else if (type == 'edit') {
                this.versionDrawer = true;
                this.versionEditId = item.id;
                this.versionForm = {
                    name: item.name,
                    sort: item.sort,
                    remark: item.remark,
                };
            }
            this.$nextTick(() => {
                this.$refs.versionFormRef?.clearValidate();
            })
        },
        // 确认新增/编辑版本
        confirmVersion() {
            this.$refs.versionFormRef.validate(valid => {
                if (!valid) return;
                this.loadSaveVersion = true;
                let req = this.versionEditId ? updateProductVersion : saveProductVersion;
                req({
                    id: this.versionEditId ? this.versionEditId : undefined,
                    productId: this.currentProduct.id,
                    ...this.versionForm,
                }).then(() => {
                    this.loadSaveVersion = false;
                    this.versionDrawer = false;
                    this.$MessageBox.MessageSuccess('保存成功');
                    this.fetchProductData();
                }).catch((err) => {
                    this.loadSaveVersion = false;
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
            })
        },
        // 删除版本
        deleteVersionItem(row) {
            deleteProductVersion({ id: row.id }).then(() => {
                this.$MessageBox.MessageSuccess('删除成功');
                this.fetchProductData();
            }).catch((err) => {
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.product-manage {
    margin-top: 22px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
    .left-panel {
        width: 46%;
        flex-shrink: 0;
    }
    .right-panel {
        flex: 1;
        padding: 12px;
        .version-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            font-size: 15px;
            font-weight: 550;
            color: #333;
        }
    }
    .save-btn {
        width: 6.9rem;
        height: 2.38rem;
        background: $primary-btn-color;
        color: #fff;
        border: none;
        border-radius: 6px;
        display: inline-block;
        margin: 0.5rem 0 3rem;
        cursor: pointer;
    }
}
</style>
